import styled, { css } from 'styled-components';
import {
  ellipsisText,
  FlexBetween,
  FlexCenterAligned,
  FlexibleDiv
} from '../../../../styled/common';
import { BookmarkArea, BookmarkContainer } from '../../../Bookmark/styled';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';

export const GalleryHeaderContainer = styled(FlexBetween)`
  width: 100%;
  height: 45px;
  position: relative;

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 0 20px;
    height: 70px;
    gap: 20px;
  }
`;

export const CloseButton = styled.div`
  padding: 10px 15px;
  height: 100%;
  width: 55px;
  cursor: pointer;

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    width: 40px;
    height: 40px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const BookmarkWrapper = styled(FlexCenterAligned)<{
  $isFavorited: boolean;
}>`
  width: 55px;
  height: 100%;
  cursor: pointer;

  ${BookmarkContainer} {
    position: static;
    transform: translate(0, 0);
  }

  ${({ $isFavorited }) =>
    !$isFavorited &&
    css`
      svg {
        fill: none;
      }
      path {
        stroke: ${({ theme }) => theme.colors.text.secondary};
      }
    `};

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    width: 50px;
    height: 50px;
    background-color: ${({ theme }) => theme.colors.background.tertiary};
    border-radius: 14px;

    @media (hover: hover) {
      &:hover {
        svg path {
          stroke: ${({ theme }) => theme.colors.systemColors.autumnRed};
        }
      }
    }

    ${BookmarkContainer} {
      width: 100%;
      height: 100%;

      ${BookmarkArea} {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    ${({ $isFavorited }) =>
      !$isFavorited &&
      css`
        path {
          stroke: ${({ theme: { colors } }) => colors.text.primary};
        }
      `}
  }
`;

export const GalleryInfo = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.white};
  margin: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    position: static;
    transform: translateX(0);
  }
`;

export const GalleryInfoPrice = styled(GalleryInfo)`
  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    flex: 0 0 auto;
  }
`;

export const GalleryInfoDescription = styled(GalleryInfo)`
  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    ${ellipsisText};
  }
`;

export const GalleryDescription = styled(FlexibleDiv)`
  gap: 10px;
  flex: 1 1 auto;
  min-width: 0;
  align-items: center;
`;

export const ActionsContainer = styled(FlexCenterAligned)`
  gap: 10px;
  flex: 0 0 auto;

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    gap: 15px;
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 22px;
  background-color: rgba(255, 255, 255, 0.25);
`;
